import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import { trellisPalette } from "components/custom/analytics/palettes";
import type { ReactNode } from "react";

const DEFAULT_COLORS = [trellisPalette[3], trellisPalette[0], trellisPalette[2], trellisPalette[1], trellisPalette[14]];

interface Props<T> {
  title?: ReactNode;
  data: T[];
  metric: string;
  accessor: (d: T) => number;
  nameAccessor: (d: T) => string;
  colors?: string[];
  height?: number;
  formatter?: (value: number | undefined) => string;
}

const PieChart = <T,>({
  title,
  data,
  metric,
  accessor,
  nameAccessor,
  colors = DEFAULT_COLORS,
  height,
  formatter,
}: Props<T>) => {
  const options: Highcharts.Options = {
    colors,
    title: { text: "" },
    chart: {
      height,
      type: "pie",
      style: {
        fontFamily: "Poppins",
        fontWeight: "300",
        fontSize: "15px",
      },
    },
    tooltip: {
      formatter: function (this) {
        if (formatter) {
          return `${this.name}: ${formatter(this.y)}`;
        }
        return `${this.name}: ${this.y}`;
      },
    },
    series: [
      {
        name: metric,
        type: "pie",
        data: data.map((d) => ({
          name: nameAccessor(d),
          y: accessor(d),
        })),
      },
    ],
  };
  return (
    <div>
      {title && <h5 className="text-center">{title}</h5>}
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PieChart;
